var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("main", {
    staticClass: "carditem",
    style: {
      marginBottom: _vm.layout === "horizontal" ? "0" : "0"
    }
  }, [_vm.layout === "horizontal" ? [_c("a-row", {
    staticClass: "carditem-row",
    attrs: {
      type: "flex",
      justify: "space-between",
      align: "middle"
    }
  }, [_vm.title ? _c("span", {
    staticClass: "title"
  }, [_vm._v(" " + _vm._s(_vm.title) + "  "), _vm.tip ? _c("a-tooltip", [_c("template", {
    slot: "title"
  }, [_vm._v(" " + _vm._s(_vm.tip) + " ")]), _c("a-icon", {
    attrs: {
      type: "exclamation-circle"
    }
  })], 2) : _vm._e()], 1) : _vm._e(), _vm._t("default")], 2)] : _vm._e(), _vm.layout === "vertical" ? [_c("a-form-item", {
    attrs: {
      colon: false
    }
  }, [_vm.title ? _c("span", {
    attrs: {
      slot: "label"
    },
    slot: "label"
  }, [_vm._v(" " + _vm._s(_vm.title) + "  "), _vm.tip ? _c("a-tooltip", {
    attrs: {
      title: _vm.tip
    }
  }, [_c("a-icon", {
    attrs: {
      type: "exclamation-circle"
    }
  })], 1) : _vm._e()], 1) : _vm._e(), _vm._t("default")], 2)] : _vm._e()], 2);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };